import { Component, OnInit, Input, OnDestroy, DoCheck } from '@angular/core';
import { GetService } from '../get.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.less']
})
export class TutorialComponent implements OnInit, DoCheck {
  @Input('show') show: boolean;
  currentStep = 0;
  changingStep = false;
  steps = [];
  translationAdded = false;
  public translation = {};
  constructor(private getService: GetService,
    public translateService: TranslateService) {
      this.getTranslation()
      }

  ngOnInit() {
    if (this.show) {
      $('body').addClass('modal-open');
    }
  }

  ngDoCheck() {
    if (Object.keys(this.translation).length > 0 && !this.translationAdded) {
      this.translationAdded = true;
      this.steps = [{
        url: `
        <source src="videos/addhorse.mp4" type="video/mp4" />  
        <!-- The fallback in case the browser doesn't recognize the HTML5 video tag -->  
        <embed src="videos/addhorse.mp4" type="video/mp4" width="{#}" height="{#}"></embed>  
        `,
        title: this.translation['step1_title'],
        description: this.translation['step1_description'],
        active: true
      }, {
        url: 
        `<source src="videos/addtreatment.mp4" type="video/mp4" />  
        <!-- The fallback in case the browser doesn't recognize the HTML5 video tag -->  
        <embed src="videos/addtreatment.mp4" type="video/mp4" width="{#}" height="{#}"></embed>`,
        title: this.translation['step2_title'],
        description: this.translation['step2_description'],
        active: false
      }, {
        url: 
        `<source src="videos/inviteuser.mp4" type="video/mp4" />  
        <!-- The fallback in case the browser doesn't recognize the HTML5 video tag -->  
        <embed src="videos/inviteuser.mp4" type="video/mp4" width="{#}" height="{#}"></embed>`,
        title: this.translation['step3_title'],
        description: this.translation['step3_description'],
        active: false
      }, {
        url: `<source src="videos/addvaccination.mp4" type="video/mp4" />  
        <!-- The fallback in case the browser doesn't recognize the HTML5 video tag -->  
        <embed src="videos/addvaccination.mp4" type="video/mp4" width="{#}" height="{#}"></embed>`,
        title: this.translation['step4_title'],
        description: this.translation['step4_description'],
        active: false
      }, {
        url: `<source src="videos/addreport.mp4" type="video/mp4" />  
        <!-- The fallback in case the browser doesn't recognize the HTML5 video tag -->  
        <embed src="videos/addreport.mp4" type="video/mp4" width="{#}" height="{#}"></embed>`,
        title: this.translation['step5_title'],
        description: this.translation['step5_description'],
        active: false
      }]
    }
  }

  hideTutorial() {
    this.getService.setShowTutorial(false);
    localStorage.setItem('showTutorial', 'false');
  }


  backStep() {
    this.changingStep = true;
    let indexStep;
    let step = this.steps.find((el: any, i: any) => {
      if (el.active) {
        indexStep = i
        return el;
      }
    });
    step.active = false;
    this.currentStep = --this.currentStep === -1 ? this.steps.length : this.currentStep;
    this.steps.splice(indexStep, 1, step);
    this.steps = this.steps.map((el, i) => {
      if (i === this.currentStep) {
        el.active = true;
      }
      return el;
    });
    setTimeout(() => this.changingStep = false, 2000)
  }

  nextStep() {
    this.changingStep = true;
    let indexStep;
    let step = this.steps.find((el: any, i: any) => {
      if (el.active) {
        indexStep = i
        return el;
      }
    });
    step.active = false;
    this.currentStep = ++this.currentStep === this.steps.length ? 0 : this.currentStep;
    this.steps.splice(indexStep, 1, step);
    this.steps = this.steps.map((el, i) => {
      if (i === this.currentStep) {
        el.active = true;
      }
      return el;
    });
    setTimeout(() => this.changingStep = false, 2000)
  }

  switchStep() {
    this.changingStep = true;
    let indexStep;
    let step = this.steps.find((el: any, i: any) => {
      if (el.active) {
        indexStep = i
        return el;
      }
    });
    step.active = false;
    this.currentStep = ++this.currentStep === this.steps.length ? 0: this.currentStep;
    this.steps.splice(indexStep, 1, step);
    this.steps = this.steps.map((el, i) => {
      if (i === this.currentStep) {
        el.active = true;
      }
      return el;
    });
    // VS:Change style after 1 seconds and move to another step
    setTimeout(() => this.changingStep = false, 1000)
  }

  getTranslation() {
      this.translateService.get('TUTORIAL.step1_title').subscribe((word: string) => {
        this.translation['step1_title'] = word;
      });
      this.translateService.get('TUTORIAL.step1_description').subscribe((word: string) => {
        this.translation['step1_description'] = word;
      });
      this.translateService.get('TUTORIAL.step2_title').subscribe((word: string) => {
        this.translation['step2_title'] = word;
      });
      this.translateService.get('TUTORIAL.step2_description').subscribe((word: string) => {
        this.translation['step2_description'] = word;
      });
      this.translateService.get('TUTORIAL.step3_title').subscribe((word: string) => {
        this.translation['step3_title'] = word;
      });
      this.translateService.get('TUTORIAL.step3_description').subscribe((word: string) => {
        this.translation['step3_description'] = word;
      });
      this.translateService.get('TUTORIAL.step4_title').subscribe((word: string) => {
        this.translation['step4_title'] = word;
      });
      this.translateService.get('TUTORIAL.step4_description').subscribe((word: string) => {
        this.translation['step4_description'] = word;
      });
      this.translateService.get('TUTORIAL.step5_title').subscribe((word: string) => {
        this.translation['step5_title'] = word;
      });
      this.translateService.get('TUTORIAL.step5_description').subscribe((word: string) => {
        this.translation['step5_description'] = word;
      });
  }

  ngOnDestroy() {
    $('body').removeClass('modal-open');
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/tutorial/tutorial.component.ts